import { defineStore } from 'pinia';
import { prdApi, prdNotificationApi } from '@/api/prdEndpoint';
import { localApi, localNotificationApi } from '@/api/localEndpoint';
import { devApi, devNotificationApi } from '@/api/devEndpoint';
import { PRD_HOSTNAME } from '@/api/common';
import { Capacitor } from '@capacitor/core';
import { api, notification } from '@zentrains/api';
import { Identifikation } from '@/model/identifikation';
import { mapToRequestItem } from '@/mapper/to-api/requestItem.ts';

export enum Backend {
  LOCAL,
  DEV,
  PRD,
}

export interface BackendItem {
  title: string;
  value: Backend;
}

export interface BackendState {
  selectedBackend: Backend;
}

export const allBackend: BackendItem[] = [
  {
    title: 'Lokal',
    value: Backend.LOCAL,
  },
  {
    title: 'Dev',
    value: Backend.DEV,
  },
  {
    title: 'Prod',
    value: Backend.PRD,
  },
];

export const useBackendStore = defineStore('backend', {
  state(): BackendState {
    return {
      selectedBackend:
        window.location.hostname === PRD_HOSTNAME || Capacitor.getPlatform() !== 'web' ? Backend.PRD : Backend.DEV,
    };
  },
  getters: {
    client(): api.v3.ZenTrainsClient {
      switch (this.selectedBackend) {
        case Backend.LOCAL:
          return localApi;
        case Backend.DEV:
          return devApi;
        case Backend.PRD:
          return prdApi;
      }
    },
    notificationClient(): notification.v3.NotificationClient {
      switch (this.selectedBackend) {
        case Backend.LOCAL:
          return localNotificationApi;
        case Backend.DEV:
          return devNotificationApi;
        case Backend.PRD:
          return prdNotificationApi;
      }
    },
  },
  actions: {
    refreshReise(allReiseId: Identifikation[]): AsyncIterable<api.v3.RefreshReiseResponse> {
      const client = this.client;
      const request: api.v3.RefreshReiseRequest = {
        allRequest: allReiseId.map(mapToRequestItem),
        calculateUIFields: true,
        withPlanWagenreihung: true,
      };
      return client.refreshReise(request);
    },
  },
  persist: true,
});
